import React, { useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import { ToggleComponent } from '../../utils/ToggleComponent'
import { ApiService } from '../../API/AxiosInstance'
import ToastAlert from '../../utils/Toaster'
import { captureException } from '@sentry/react'
import { getErrorMessage } from '../../utils/validation'
import { colors } from '../../Theme/tokens';

const topicData = [
    {id: 1, name: "Investment insights & market trends", subscribed: false}, {id: 2, name: "New investment opportunities (IPOS, ETFs, crypto listings)", subscribed: false}, {id: 3, name: "Educational content & investment strategies", subscribed: false},
    {id: 4, name: "Latest news on Web3", subscribed: false}, {id: 5, name: "Latest news on finance", subscribed: false}, {id:6, name:"App updates (New feature, Feature Enhancement, Feature removal)", subscribed: false},
    {id:7, name: "Product updates (New Product, Product Information updated, Product removed)", subscribed: false}, {id:8, name:"Policy & regulatory updates", subscribed: false}
]

const NotificationTopics = () => {
    const [notificationData, setNotificationData] = useState(topicData) 
    const [loading, setLoading] = useState(false)
    const userId =  JSON.parse(localStorage.getItem('userData')).sub_id || ''
    const [toastStatus,setToastStatus] = useState({color:'',status:false,message:'',icon:''})

    useEffect(() => {
        getSubscribedTopics()
    },[])

    const getSubscribedTopics = async() => {
        setLoading(true)
        try {
            const response = await ApiService().get(`notifications/users/${userId}/subscriptions/topics`)
            console.log("getSubscribedTopics response ",response)
            if(response?.data?.data?.length >0) {
                const getTopicId = response?.data?.data?.map((subscribedTopic) =>  subscribedTopic?.topic?.topicId)
                if(getTopicId?.length >0) {
                    const updatedNotificationData = notificationData?.map((topic) => {
                        if(getTopicId?.includes(topic?.id)) {
                            return {...topic, subscribed: true}
                        }
                        return topic
                    }) 
                    setNotificationData(updatedNotificationData)
                }
                
            }
        } catch(error)  {
            console.log("getSubscribedTopics error ",error)
            captureException(error)
        } finally {
            setLoading(false)
        }
        console.log('userId ',userId)
    }
    
    const handleToggleChange = async(e, id) => {
        console.log(e.target.checked)
        const isSuccess =  await subscribeOrUnsubscribe(id,e.target.checked)
        console.log("isSuccess ",isSuccess?.status, isSuccess?.toggleStatus)
        if(isSuccess?.status) {
            let requiredObject = notificationData?.map(item => item.id == id ? {...item, subscribed: isSuccess?.toggleStatus} : item)
            setNotificationData(requiredObject)
        }
        
    }

    const subscribeOrUnsubscribe = async(topicId, isToggle) => {
        setLoading(true)
        console.log(topicId, isToggle)
        let url;
        let payload;
        if(isToggle) {
            url = `notifications/topics/${topicId}/subscribe`
            payload = {
                userId: userId,
                types: ["EMAIL","PUSH"]
            }
        } else {
            url = `notifications/users/${userId}/subscriptions/topics/${topicId}`
            payload = {types:  ["PUSH", "EMAIL"]}
        }
        try {   
            let response;

           
            if (isToggle) {
                response = await ApiService().post(url, payload);
            } else {
                response = await ApiService().post(`${url}/delete`, { data: payload});
            }
            console.log("subscribeOrUnsubscribe response ",response)
            setToastStatus({color:'green',status:true,message: response?.data?.message,icon:'tick'})
            setTimeout(()=>{
              setToastStatus({color:'',status:false, message:""})
          },3000)

            return {status: true, toggleStatus: isToggle}
        } catch(error) {
            console.log("subscribeOrUnsubscribe error ",error)
            setToastStatus({color:'red',status:true,message: getErrorMessage(error),icon:'close'})
            captureException(error)
            setTimeout(()=>{
              setToastStatus({color:'',status:false, message:""})
          },3000)
            return {status: false, toggleStatus: isToggle}
        } finally {
            setLoading(false)
        }
    }

    const CommonBorder = (props) => {
        return(
            <Box 
                sx={{borderBottom:`1px solid ${colors.border.default}`, ...props.sx}}
            />
        )
    }

  return (
    <>
    <ToastAlert  message={toastStatus?.message} status={toastStatus?.status}  color={toastStatus?.color} icon={toastStatus?.icon} closeFunc={() => setToastStatus({color:'',status:false})} />  
    <Box mt={2} sx={{  borderRadius: '18px', padding: '20px', display: 'flex', gap: '5px', backgroundColor: 'white', flexDirection: 'column' }}>
        <Box sx={{ mb:2 }}>
            <Typography sx={{color: colors.text.primary, fontSize:{xs:"18px",sm:"22px"}, fontWeight:550}} >Subscribe to notifications</Typography>
        </Box>

        <Box sx={{display:"flex", flexDirection:"column", gap:3}}>
        {notificationData?.map((item, index) => (
            <Box key={item?.id}>
             <ToggleComponent 
             labelText={item?.name}
             notificationLabel={true}
             notificationTopicId={item?.id}
             isToggle={item?.subscribed}
             disabled={loading}
             handleToggleChange={(e) => handleToggleChange(e,item.id)}
            />
            {/* <CommonBorder sx={{display: notificationData?.length === index + 1 ? "none" : "block", mt:3}} /> */}
         </Box>
        ))}
           
        </Box>
        
    </Box>        
    </>
  )
}

export default NotificationTopics